export default function React_RenderHTML() {
  return (
    <div>
      <h1>React_RenderHTML Component</h1>
      <p>This is the React_RenderHTML tutorial page.</p>
    </div>
  );
}
